// Auth State

export default {
  authUserData: {},
  authToken: null,
  loginCashiersList: []
}
